import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useEobContext } from "../../context/EobFormContext";
import { getScrollbarSize, List } from "react-window";

const ClaimSummary = ({ eobFormGetValues, setShowClaimSummary }) => {
  const {
    jumpToPage,
     setMoveClaimIndex :setSelectedIndex ,
    fullclaimData,
    setFullClaimData, 
    tableHeight,
    gotoClaim,
    moveClaimDown,
    moveClaimUp,
    moveClaimIndex :selectedIndex,
    
  } = useEobContext();

  const [activeTab, setActiveTab] = useState("claims");
  const [filters, setFilters] = useState({
    patientAccount: "",
    payerClaim: "",
    statusCode: "",
    from: "",
    to: "",
  });
  // const [selectedIndex, setSelectedIndex] = useState(null);

  const formValues = eobFormGetValues();

  // --- Process Claims ---
  const processedClaims = useMemo(() => {
    if (!fullclaimData) return [];
    return fullclaimData.map((claim, index) => {
      const claimBilled = claim.service_lines?.reduce((s, sl) => s + parseFloat(sl.billed || 0), 0) || 0;
      const claimPaid = claim.service_lines?.reduce((s, sl) => s + parseFloat(sl.paid || 0), 0) || 0;
      const claimBalance = claimBilled - claimPaid;
      return { ...claim, index: index + 1, claim_billed: claimBilled, claim_paid: claimPaid, claim_balance: claimBalance };
    });
  }, [fullclaimData]);

  // --- Filter Claims ---
  const filteredClaims = useMemo(() => {
    return processedClaims.filter(claim => {
      return (
        (!filters.patientAccount.trim() || claim.patient_account_number.toLowerCase().includes(filters.patientAccount.toLowerCase())) &&
        (!filters.payerClaim.trim() || claim.payer_claim_number.toLowerCase().includes(filters.payerClaim.toLowerCase())) &&
        (!filters.statusCode.trim() || claim.status_code.toString().includes(filters.statusCode.toLowerCase())) &&
        (!filters.from.trim() || claim.page_from.toLowerCase().includes(filters.from.toLowerCase())) &&
        (!filters.to.trim() || claim.page_to.toLowerCase().includes(filters.to.toLowerCase()))
      );
    });
  }, [processedClaims, filters]);

  const handleFilterChange = useCallback((field, value) => setFilters(p => ({ ...p, [field]: value })), []);
  const clearAllFilters = useCallback(() => setFilters({ patientAccount: "", payerClaim: "", statusCode: "", from: "", to: "" }), []);
  const hasActiveFilters = Object.values(filters).some(f => f.trim() !== "");

  const handleKeyUp = (e) => {
    if (e.key === "Escape") {
      setShowClaimSummary(false);
      setSelectedIndex(null); // reset selection
    } else if (e.key === "ArrowUp") {
      setSelectedIndex(prev => {
        if (prev === null) return 0; // start from first row
        return Math.max(prev - 1, 0); // move up, not less than 0
      });
    } else if (e.key === "ArrowDown") {
      setSelectedIndex(prev => {
        if (prev === null) return 0; // start from first row
        return Math.min(prev + 1, filteredClaims.length - 1); // move down, not exceed last row
      });
    }
  };
  useEffect(() => { window.addEventListener("keyup", handleKeyUp); return () => window.removeEventListener("keyup", handleKeyUp); }, []);

  const handleRowClicked = useCallback((claim, index) => {
    setSelectedIndex(index);
    jumpToPage(claim.page_to);
  }, [jumpToPage]);

  const handleRowDoubleClicked = useCallback(
    (claim, index) => {
      setShowClaimSummary(false);
      jumpToPage(claim.page_to);
      gotoClaim(index);
      setSelectedIndex(null);
    },
    [setShowClaimSummary, jumpToPage, gotoClaim, setSelectedIndex]
  );

  // const moveClaimUp = () => {
  //   if (selectedIndex === null || selectedIndex === 0) return;
  //   const newList = [...fullclaimData];
  //   [newList[selectedIndex - 1], newList[selectedIndex]] = [newList[selectedIndex], newList[selectedIndex - 1]];
  //   setFullClaimData(newList);
  //   setSelectedIndex(selectedIndex - 1);
  // };

  // const moveClaimDown = () => {
  //   if (selectedIndex === null || selectedIndex === fullclaimData.length - 1) return;
  //   const newList = [...fullclaimData];
  //   [newList[selectedIndex + 1], newList[selectedIndex]] = [newList[selectedIndex], newList[selectedIndex + 1]];
  //   setFullClaimData(newList);
  //   setSelectedIndex(selectedIndex + 1);
  // };

  const handleClaimTotal = useCallback((claims, key) => {
    const sum = claims.reduce((acc, c) => acc + (c[key] || 0), 0);
    return parseFloat(sum).toFixed(2);
  }, []);

  const calculateClaimTotals = (claims) => {
  return claims.reduce((totals, claim) => ({
    claimBilled: totals.claimBilled + (parseFloat(claim.claim_billed) || 0),
    claimPaid: totals.claimPaid + (parseFloat(claim.claim_paid) || 0),
    claimPrAdjustments: totals.claimPrAdjustments + (parseFloat(claim.claim_pr_adjustments) || 0),
    slPrAdjustments: totals.slPrAdjustments + (parseFloat(claim.sl_pr_adjustments) || 0),
    claimNonPrAdjustments: totals.claimNonPrAdjustments + (parseFloat(claim.claim_non_pr_adjustments) || 0),
    slAdjustments: totals.slAdjustments + (parseFloat(claim.sl_adjustments) || 0),
    claimBalance: totals.claimBalance + (parseFloat(claim.claim_balance) || 0)
  }), {
    claimBilled: 0,
    claimPaid: 0,
    claimPrAdjustments: 0,
    slPrAdjustments: 0,
    claimNonPrAdjustments: 0,
    slAdjustments: 0,
    claimBalance: 0
  });
};

const claimTotals = calculateClaimTotals(filteredClaims);
const checkAmount = parseFloat(formValues?.check_amount) || 0;
const diff = checkAmount - claimTotals.claimPaid;

  return (
    <div className="topblock-wrapper eob_block accordion-collapse collapse show h-100">
      <div className="d-flex flex-column claim-summary-header-new">
        {/* --- Tabs & Filters --- */}
        <div className="d-flex align-items-center justify-content-between p-2 pb-1" style={{ borderBottom: "1px solid #dee2e6", backgroundColor: "#f8f9fa", position: "sticky", top: 0, zIndex: 20 }}>
          <div className="d-flex me-3 gap-1">
            <button onClick={() => setActiveTab("claims")} className={`exclude-disabled btn btn-sm ${activeTab === "claims" ? "btn-claim-summary" : "btn-claim-summary-inactive"}`} type = 'button'>Claims ({filteredClaims.length})</button>
            <button onClick={() => setActiveTab("plb")} className={` exclude-disabled btn btn-sm ${activeTab === "plb" ? "btn-claim-summary" : "btn-claim-summary-inactive"}`} type = 'button'>PLB ({formValues?.plb_adjustments?.length || 0})</button>
          </div>

          {activeTab === "claims" && (
            <div className="d-flex align-items-center flex-grow-1">
              <Form.Control size="sm" type="text" placeholder="Patient Account" value={filters.patientAccount} onChange={e => handleFilterChange("patientAccount", e.target.value)} className="me-2" style={{ width: 150 }} />
              <Form.Control size="sm" type="text" placeholder="Payer Claim" value={filters.payerClaim} onChange={e => handleFilterChange("payerClaim", e.target.value)} className="me-2" style={{ width: 150 }} />
              <Form.Control size="sm" type="text" placeholder="Status" value={filters.statusCode} onChange={e => handleFilterChange("statusCode", e.target.value)} className="me-2" style={{ width: 100 }} />
              {hasActiveFilters && <button className="btn btn-outline-danger btn-sm" type="button" onClick={clearAllFilters} style={{ fontSize: "0.75rem" }}>Clear Filters</button>}
            </div>
          )}


          {/* --- Summary Labels --- */}
          {activeTab === "claims" && (
            <div className="d-flex align-items-center gap-3 px-3 py-2" >
              <div className="d-flex align-items-center">
                <span className="text-muted small me-2">Claim Billed:</span>
                <span className="fw-semibold">{claimTotals.claimBilled.toFixed(2)}</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="text-muted small me-2">Claim Paid:</span>
                <span className="fw-semibold">{claimTotals.claimPaid.toFixed(2)}</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="text-muted small me-2">Check Total:</span>
                <span className="fw-semibold">{checkAmount.toFixed(2)}</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="text-muted small me-2">Diff:</span>
                <span className={`fw-semibold {Math.abs(diff) > 0.01 ? 'text-danger' : 'text-success'}`}>
                  {diff.toFixed(2)}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* --- Table --- */}
        <div className= " flex-grow-1 " style={{ height: '100%' }}>
          {activeTab === "claims" && <ClaimsTable claims={filteredClaims} transactionType= {formValues?.transaction_type} handleRowClicked={handleRowClicked} selectedIndex={selectedIndex}  handleRowDoubleClicked={handleRowDoubleClicked}  tableHeight={tableHeight}/>}
          {activeTab === "plb" && <PlbTable plbs={formValues?.plb_adjustments || []} />}
        </div>
      </div>
    </div>
  );
};

// --- Claims Table ---
// Move ClaimRow outside and above ClaimsTable
function ClaimRow({ index, claims, handleRowClicked, handleRowDoubleClicked, style, selectedIndex ,transaction_835Lite ,transaction_835 ,handleClaimTotal }) {
  const claim = claims[index];
  if (!claim) return null;

  const isSelected = index === selectedIndex;


  const claimAdjTotal = handleClaimTotal(claim?.claim_adjustments,'amount')
  const slADJ = Number(claim.sl_amount || 0) - Number(claim.sl_patres || 0)

  return (
    <div
      className={`d-flex flex-row align-items-center ps-3 border-bottom hover-row ${isSelected ? 'bg-primary bg-opacity-10' : ''}`}
      style={{ ...style, cursor: "pointer" }}
      onClick={() => handleRowClicked(claim, index)}
      onDoubleClick={(e) => {
        handleRowDoubleClicked(claim, index);
        e.stopPropagation();
      }}
    >
      <div style={{ width: 50  }} className="mx-2">{claim.index}</div>
      <div style={{ width: 50  }} className="mx-2">{claim.page_from}</div>
      <div style={{ width: 50  }} className="mx-2">{claim.page_to}</div>
      <div style={{ width: 200  }} className="mx-2">{claim.patient_account_number}</div>

      {transaction_835 && (
        <>
          <div style={{ width: 200  }} className="mx-2">{claim.payer_claim_number}</div>
          <div style={{ width: 100  }} className="mx-2">{claim.status_code}</div>
        </>
      )}

      <div style={{ width: 145   }} className="mx-2 ">{Number(claim.claim_billed || 0).toFixed(2)}</div>
      <div style={{ width: 145   }} className="mx-2 ">{Number(claim.claim_paid || 0).toFixed(2)}</div>

      {transaction_835 && (
        <>
          <div style={{ width: 145   }} className="mx-2 ">{Number(claim.claim_adjustment_total_pr || 0).toFixed(2)}</div>
          <div style={{ width: 145   }} className="mx-2 ">{Number(claim.sl_patres || 0).toFixed(2)}</div>
          <div style={{ width: 145   }} className="mx-2 ">{Number(claimAdjTotal || 0).toFixed(2)}</div>
          <div style={{ width: 145   }} className="mx-2 ">
            {(slADJ).toFixed(2)}
          </div>
          <div style={{ width: 145   }} className="mx-2 ">
            {(
              Number(claim.claim_adjustment_total_pr || 0) - (
                Number(claim.sl_patres || 0) +
                Number(claimAdjTotal || 0) +
                slADJ
              )
            ).toFixed(2)}
          </div>
        </>
      )}
       {transaction_835Lite && (
        <>
        <div style={{ width: 300  }} className="mx-2">{claim?.patient_first_name}</div>
        <div style={{ width: 300  }} className="mx-2">{claim?.patient_last_name}</div>
        <div style={{ width: 200  }} className="mx-2">{claim?.period_start}</div>
        <div style={{ width: 200  }} className="mx-2">{claim?.period_end}</div>
        </>
        )}
     
    </div>
  );
}

function ClaimsTable({
  claims,
  handleRowClicked,
  handleRowDoubleClicked,
  selectedIndex,
  tableHeight = 300,
  rowHeight = 40,
  transactionType
}) {
  const scrollbarWidth = getScrollbarSize();

const transaction_835 = ['PAYMENT835', 'PATIENT_PAY_835', 'CORRESPONDENCE_835'].includes(transactionType);
const transaction_835Lite = transactionType === 'PAYMENT835_LITE';

  const handleClaimTotal = useCallback((claims = [], key) => {
    const sum = claims.reduce((acc, c) => Number(acc) + Number(c?.[key] || 0), 0);
    return parseFloat(sum).toFixed(2);
  }, []);

  return (
    <div className="d-flex flex-column border border-secondary" style={{height: 'calc(100% - 75px)' ,minHeight:'100% '}} >
      {/* Header */}
      <div className="d-flex flex-row bg-light fw-bold px-2 py-2 sticky-top border-bottom">
        <div className="d-flex flex-row bg-light fw-bold px-2 py-2 sticky-top border-bottom">
          <div style={{ width: 50 }} className='mx-2'>#</div>
          <div style={{ width: 50 }} className='mx-2'>From</div>
          <div style={{ width: 50 }} className='mx-2'>To</div>
          <div style={{ width: 200 }} className='mx-2'>Patient Account</div>

          {transaction_835 && (
            <>
              <div style={{ width: 200 }} className='mx-2'>Payer Claim</div>
              <div style={{ width: 100 }} className='mx-2'>Status Code</div>
            </>
          )}

          <div style={{ width: 145 }} className='mx-2'>Billed</div>
          <div style={{ width: 145 }} className='mx-2'>Paid</div>

          {transaction_835 && (
            <>
              <div style={{ width: 145 }} className='mx-2'>CL Adj (PR)</div>
              <div style={{ width: 145 }} className='mx-2'>SL Adj (PR)</div>
              <div style={{ width: 145 }} className='mx-2'>CL Adj</div>
              <div style={{ width: 145 }} className='mx-2'>SL Adj</div>
              <div style={{ width: 145 }} className='mx-2'>Diff</div>
            </>
          )}
            {transaction_835Lite && (
            <>
              <div style={{ width: 300 }} className='mx-2'>Patient First Name</div>
              <div style={{ width: 300 }} className='mx-2'>Patient Last Name</div>
              <div style={{ width: 200 }} className='mx-2'>Period Start</div>
              <div style={{ width: 200 }} className='mx-2'>Period End</div>
            </>
          )}
        </div>

        <div style={{ width: scrollbarWidth }}  />
      </div>

      {/* Virtualized List */}
    <div className="d-flex flex-column " style={{height: 'calc(100% - 105px)' ,}} >

      <List
        rowComponent={ClaimRow}
        rowCount={claims.length}
        rowHeight={30}
        rowProps={{ claims, handleRowClicked, handleRowDoubleClicked, selectedIndex, transaction_835Lite ,transaction_835  ,handleClaimTotal}}
        width="100%"
        height='100%'
      />
      
    </div>
    </div>
  );
}
// --- PLB Table ---

function PlbTable({ plbs }) {
  const height = 300;
  const scrollbarWidth = getScrollbarSize();

  return (
    <div className="d-flex flex-column border " style={{ height:'100%' }}>
      <div className="d-flex flex-row bg-light fw-bold px-2 py-2 border-bottom">
        <div style={{ width: "60px" }}>#</div>
        <div style={{ width: "320px" }}>Account Number</div>
        <div style={{ width: "240px" }}>PLB Amount</div>
        <div style={{ width: "160px" }}>Page</div>
        <div style={{ width: scrollbarWidth }} />
      </div>

     <div className="d-flex flex-column " style={{height: 'calc(100% - 85px)' ,}} >
        {plbs.length > 0 ? (
          <List
            rowComponent={PlbRow}
            rowCount={plbs.length}
            rowHeight={30}
            rowProps={{ plbs }}
            width="100%"
            height='100%'
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center text-muted mt-2">
            No PLB adjustments available
          </div>
        )}
      </div>
    </div>
  );
}

function PlbRow({ index, plbs, style }) {
  const plb = plbs[index];
  if (!plb) return null;

  return (
    <div className="d-flex flex-row px-2 border-bottom" style={style}>
      <div style={{ width: "60px" }}>{index + 1}</div>
      <div style={{ width: "320px" }}>{plb.patient_account_number || "---------"}</div>
      <div style={{ width: "240px" }}>{parseFloat(plb.plb_amt || 0).toFixed(2)}</div>
      <div style={{ width: "160px" }}>{plb.plb_page || "---------"}</div>
    </div>
  );
}

export default ClaimSummary;
